import React from "react";

const HomeBanner = () => {
  return (
    <div className="banner">
      <div className="mx-auto max-w-screen-xl">
        <div className="content">
          <h2>Lorem ipsum dolor amet consectetuer. Lorem</h2>
          <p>
            Lorem ipsum dolor ngồi amet consectetuer lorem ipsum dolor ngồi amet
            consectetuer lorem ipsum dolor ngồi amet consectetuer lorem ipsum
            dolor{" "}
          </p>
          <button>Contact us</button>
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
